import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Expedia(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_10225_142838)">
        {!hideBackground && <rect fill="#072F54" height="24" rx={isRound ? '100%' : 0} width="24" />}
        <path
          d="M15.133 12.2985L15.4857 13.8133L14.8558 21.1121L15.629 20.8611L18.6077 11.3055L23.0711 10.0324C23.641 9.84916 24.2155 9.51356 24.6067 9.26262C24.4696 8.87005 24.3125 8.48364 24.1385 8.10646C23.6857 8.10338 23.0912 8.13418 22.5675 8.26657L18.1133 9.54281L10.5433 2.99998L9.75622 3.19704L14.1442 9.06095L14.6633 10.5235L10.4462 11.7304L-0.222656 15.4329C-0.188772 15.6546 -0.150267 15.8747 -0.105602 16.0933L10.9514 13.4916L15.133 12.2985Z"
          fill="#FBC108"
        />
      </g>
      <defs>
        <clipPath id="clip0_10225_142838">
          <rect fill="white" height="24" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
}

Expedia.propTypes = propTypes;
Expedia.defaultProps = defaultProps;

export default Expedia;
